export default "__VITE_ASSET__c76e7a6d__"